import React from 'react';
import SocialIcons from './common/SocialIcons';
import '../styles/footer.css';
import { useLanguage } from "./common/LanguageContext";

function Footer() {
  const { translations } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <img src="/NIRIVS_logo.svg" alt="NIRIVS Logo" className="logo-image-footer" />
          <SocialIcons size="1.55rem"/>
          <address className="footer-contact">
            <div>{translations.footer.phone}<a href="tel:+79281300788" className='footer-link'>8 928 1300 7 88</a></div>
            <div>{translations.footer.mail}<a href="mailto:mail@nirivs.ru" className='footer-link'>mail@nirivs.ru</a></div>
          </address>
        </div>
      </div>
    </footer>
  );
}

export default Footer;